import { createMemo, JSX, splitProps } from 'solid-js'
import styles from './st-image.module.css'
import { theme, transformImagePath } from 'common';

export class ImageProps {
    alt!: string;
}

export default function Image(props: ImageProps & JSX.HTMLElementTags['img']) {
    const [local, other] = splitProps(props, ['src', 'class', 'children'])

    const src = createMemo(() => {
        // transformImagePath calls theme() under the hood, so this should be reactive
        return transformImagePath(props.src)
    })

    return (
        <img
            class={`${styles['st-image']} ${local.class ?? ''}`}
            src={src()}
            {...other}
        />
    );
}

Image.defaultProps = new ImageProps();